export default {
  sellerComment: {
    id: 'merchant_commentary',
    defaultMessage: 'Refurbisher comments:',
  },
}
